/* eslint-disable consistent-return */
import useEffect from '../useEffect';
/**
 * Prevent the scrolling behavior in the background when the popup/modal component is mounted,
 * and remove the prevent-scrolling behavior when the popup/modal component is unmounted.
 *
 * #NOTES
 * We apply the additional style to the document body in order to
 * handle the overflow scrolling behavior on iOS Safari.
 * Reference: https://markus.oberlehner.net/blog/simple-solution-to-prevent-body-scrolling-on-ios/
 */
export function usePreventScrolling(isDisabled = false) {
    const body = document.body;
    useEffect(() => {
        if (isDisabled)
            return;
        /* disable body from scrolling */
        const scrollPosition = window.scrollY;
        body.style.overflow = 'hidden';
        body.style.position = 'fixed';
        body.style.top = `-${scrollPosition}px`;
        body.style.width = '100%';
        return () => {
            if (isDisabled)
                return;
            /* enable body to scroll */
            body.style.removeProperty('overflow');
            body.style.removeProperty('position');
            body.style.removeProperty('top');
            body.style.removeProperty('width');
            window.scrollTo(0, scrollPosition);
        };
    }, []);
}
